var copyObj = function copyObj(obj) {
  return JSON.parse(JSON.stringify(obj));
};

var formatDate = function formatDate(date) {
  var dd = date.split('/')[1];
  var mm = date.split('/')[0];
  var yyyy = date.split('/')[2];
  var formattedDate = yyyy + '-' + mm + '-' + dd;
  return formattedDate;
};

module.exports = {
  copyObj: copyObj,
  formatDate: formatDate
};